import React from 'react';
import Btn from '../../../components/ui/Btn';

// Lo que falta, dicho en una línea y con el botón que lo resuelve. Cuando todo está listo, dice qué está pasando.
export default function NextStep({ next, steps, project, onGo, onPublish, onEngine, canPublish }) {
  const problem = steps.find((s) => s.state === 'problem');
  if (problem?.key === 'credential') {
    return <Callout tone="caution" text="OpenAI rechazó la clave de este agente: no puede responder hasta que la cambies." action={<Btn onClick={() => onGo('credential')}>Cambiar clave</Btn>} />;
  }
  const blockedByN8n = Boolean(project?.phone_number_id);
  const map = {
    credential: { text: 'Dale una clave de OpenAI para que pueda responder.', action: <Btn variant="primary" onClick={() => onGo('credential')}>Agregar clave</Btn> },
    prompt: { text: 'Escribe sus instrucciones: para quién trabaja, cómo habla y qué no debe hacer.', action: <Btn variant="primary" onClick={() => onGo('prompt')}>Escribir instrucciones</Btn> },
    published: { text: 'Publica para que los canales usen estas instrucciones.', action: <Btn variant="primary" onClick={onPublish} disabled={!canPublish}>Publicar</Btn> },
    channel: { text: 'Conecta un canal para que reciba mensajes.', action: <Btn variant="primary" onClick={() => onGo('channels')}>Conectar un canal</Btn> },
    engine: blockedByN8n
      ? { text: `«${project?.name}» tiene un número de WhatsApp que atiende n8n. Hay que migrarlo antes de encender el motor en este proyecto.`, action: null, tone: 'caution' }
      : { text: `Enciende el motor en «${project?.name}» para que este agente empiece a responder.`, action: <Btn variant="primary" onClick={() => onEngine('runtime')}>Encender motor</Btn> },
  };
  if (!next) {
    const channels = steps.find((s) => s.key === 'channel')?.detail;
    return <Callout tone="live" text={`Atendiendo mensajes en ${channels}.`} action={<Btn variant="ghost" onClick={() => onEngine('n8n')}>Apagar motor</Btn>} />;
  }
  const m = map[next];
  return <Callout tone={m.tone || 'signal'} text={m.text} action={m.action} />;
}

function Callout({ tone, text, action }) {
  const bar = { signal: 'bg-signal', live: 'bg-live', caution: 'bg-caution' }[tone];
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-2xl bg-panel ring-1 ring-line px-5 py-4" role="status">
      <span className={`hidden sm:block h-2.5 w-2.5 shrink-0 rounded-full ${bar} ${tone === 'live' ? 'animate-pulse' : ''}`} aria-hidden />
      <p className="flex-1 text-[14.5px] text-fg">{text}</p>
      {action}
    </div>
  );
}
